import { Box } from '@amzn/awsui-components-react-v3';
import React, { ReactElement } from 'react';

export type KeyValueProps = {
  label: string;
  children: ReactElement | string | number | undefined | null;
  fontWeight?: 'bold' | 'light' | 'normal' | 'heavy';
};

export default function KeyValue(props: KeyValueProps): ReactElement {
  const { label, children, fontWeight } = props;
  return (
    <div>
      <Box margin={{ bottom: 'xxxs' }} color="text-label" fontWeight={fontWeight}>
        {label}
      </Box>
      <div>{children || '-'}</div>
    </div>
  );
}
